export const env = (key: string) => {
    //@ts-ignore
    return window._env_[key]
}